let openApproveStandbyDialogImpl:
  | ((userId: string, standbyReason?: string) => void)
  | undefined;

export function registerOpenApproveStandbyDialog(
  impl: (userId: string, standbyReason?: string) => void
): () => void {
  openApproveStandbyDialogImpl = impl;
  return () => {
    if (openApproveStandbyDialogImpl === impl) {
      openApproveStandbyDialogImpl = undefined;
    }
  };
}

export function openApproveStandbyDialog(
  userId: string,
  standbyReason?: string
): void {
  if (!openApproveStandbyDialogImpl) {
    console.error("ApproveStandbyDialogHost is not mounted");
    return;
  }
  openApproveStandbyDialogImpl(userId, standbyReason);
}
